"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roles = void 0;
const user_roles_js_1 = require("./user-roles.js");
const permissions_js_1 = require("./permissions.js");
exports.roles = {
    [user_roles_js_1.UserRoles.GUEST]: {
        title: 'Guest',
        permissions: [],
    },
    [user_roles_js_1.UserRoles.STUDENT]: {
        title: 'Student',
        permissions: [],
    },
    [user_roles_js_1.UserRoles.ADMIN]: {
        title: 'Admin',
        permissions: [
            permissions_js_1.Permissions.Administrators.READ,
            permissions_js_1.Permissions.Profile.READ,
            permissions_js_1.Permissions.Reports.Score.READ,
            permissions_js_1.Permissions.Reports.Progress.READ,
            permissions_js_1.Permissions.Reports.Student.READ,
            permissions_js_1.Permissions.Organizations.LIST,
            permissions_js_1.Permissions.Users.LIST,
            permissions_js_1.Permissions.Administrations.LIST,
        ],
    },
    [user_roles_js_1.UserRoles.PLATFORM_ADMIN]: {
        title: 'Platform Admin',
        permissions: [
            permissions_js_1.Permissions.Administrators.READ,
            permissions_js_1.Permissions.Administrators.CREATE,
            permissions_js_1.Permissions.Administrators.UPDATE,
            permissions_js_1.Permissions.Profile.ALL,
            permissions_js_1.Permissions.Reports.Score.READ,
            permissions_js_1.Permissions.Reports.Progress.READ,
            permissions_js_1.Permissions.Reports.Student.READ,
            permissions_js_1.Permissions.Organizations.ALL,
            permissions_js_1.Permissions.Administrations.ALL,
            permissions_js_1.Permissions.Users.ALL,
        ],
    },
    [user_roles_js_1.UserRoles.LAUNCH_ADMIN]: {
        title: 'Launch Admin',
        permissions: [
            permissions_js_1.Permissions.Administrators.READ,
            permissions_js_1.Permissions.Profile.READ,
            permissions_js_1.Permissions.Reports.Score.READ,
            permissions_js_1.Permissions.Reports.Progress.READ,
            permissions_js_1.Permissions.Reports.Student.READ,
            permissions_js_1.Permissions.Organizations.LIST,
            permissions_js_1.Permissions.Users.LIST,
            permissions_js_1.Permissions.Administrations.LIST,
            permissions_js_1.Permissions.Tasks.LAUNCH,
        ],
    },
    [user_roles_js_1.UserRoles.SUPER_ADMIN]: {
        title: 'Super Admin',
        permissions: [],
    },
};
